import { setOnSuccess } from 'lp-redux-api';
import { selectorForSlice, setState, unsetState } from 'lp-redux-utils';
import { handleActions } from 'redux-actions';
import * as apiActions from '../apiActions';
import * as actions from './actions';
const reducerKey = 'creditApplication';
const slice = 'root.creditPortal.creditApplication';
const initialState = {
    proveApp: null,
    proveVerify: null,
    proveFail: null,
    proveBypass: undefined,
    approveChargeFlowData: null,
};
const reducer = handleActions({
    [actions.clearProveFail.toString()]: unsetState('proveFail'),
    [actions.clearProveApp.toString()]: unsetState('proveApp'),
    [actions.clearProveVerify.toString()]: unsetState('proveVerify'),
    [actions.clearProveBypass.toString()]: unsetState('proveBypass'),
    [actions.clearActiveOfferId.toString()]: unsetState('activeOfferId'),
    [actions.setActiveOfferId.toString()]: setState('activeOfferId'),
    [actions.setProveFail.toString()]: setState('proveFail'),
    [actions.setProveApp.toString()]: setState('proveApp'),
    [actions.setProveVerify.toString()]: setState('proveVerify'),
    [actions.setProveBypass.toString()]: setState('proveBypass'),
    [actions.setApplicationEnvironment.toString()]: setState('applicationEnvironment'),
    [actions.clearApplicationEnvironment.toString()]: unsetState('applicationEnvironment'),
    [actions.clearPractice.toString()]: unsetState('practice'),
    [actions.setPractice.toString()]: setState('practice'),
    [actions.setPersonalInfo.toString()]: setState('personalInfo'),
    [actions.setPersonalInfoOTA.toString()]: setState('personalInfoOTA'),
    [actions.setPrequalification.toString()]: setState('prequalification'),
    [actions.setPrequalifications.toString()]: setState('prequalifications'),
    [actions.setLenderReferenceId.toString()]: setState('lenderReferenceId'),
    [actions.setLenderName.toString()]: setState('lenderName'),
    [actions.setCreditApplication.toString()]: setState('creditApplication'),
    [actions.clearPersonalInfo.toString()]: unsetState('personalInfo'),
    [actions.setApprovedApplication.toString()]: setState('approvedApplication'),
    [actions.setPendingDecisionDetails.toString()]: setState('pendingDecisionDetails'),
    [actions.setApproveChargeFlowData.toString()]: setState('approveChargeFlowData'),
    [actions.setSigningUrl.toString()]: setState('signingUrl'),
    [actions.clearApproveChargeFlowData.toString()]: unsetState('approveChargeFlowData'),
    [apiActions.applyAfterPrequalification]: setOnSuccess('approvedApplication'),
    [apiActions.submitFullApplication]: setOnSuccess('approvedApplication'),
}, initialState);
const select = selectorForSlice(slice);
const selectors = {
    activeOfferId: select('activeOfferId'),
    approveChargeFlowData: select('approveChargeFlowData'),
    approvedApplication: select('approvedApplication'),
    applicationEnvironment: select('applicationEnvironment'),
    creditApplication: select('creditApplication'),
    lenderName: select('lenderName'),
    lenderReferenceId: select('lenderReferenceId'),
    pendingDecisionDetails: select('pendingDecisionDetails'),
    personalInfo: select('personalInfo'),
    personalInfoOTA: select('personalInfoOTA'),
    practice: select('practice'),
    preQualificationData: select('preQualificationData'),
    prequalification: select('prequalification'),
    prequalifications: select('prequalifications'),
    proveApp: select('proveApp'),
    proveBypass: select('proveBypass'),
    proveFail: select('proveFail'),
    proveVerify: select('proveVerify'),
    signingUrl: select('signingUrl'),
};
export { reducer, selectors, reducerKey };
